import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_MONITORING_QUEUE_ENTRIES_COUNT } from "../types";
import {
  getMonitoringQueueEntriesCountPending,
  getMonitoringQueueEntriesCountFulfilled,
  getMonitoringQueueEntriesCountRejected,
} from "../actions";
import { sendApiRequest, notifyError } from "../../../actions";
import { MONITORING_QUEUE_ENTRY_MESSAGES } from "../constants/monitoringQueueEntryMessages";
import generateError from "../../../utilities/generateError";
import { setNoEntriesMessage } from "../actions";

const createPayload = (payload) => ({
  method: "post",
  url: "monitoringqueueentry/count",
  onSuccess: [
    (response) =>
      response.data === 0
        ? setNoEntriesMessage(MONITORING_QUEUE_ENTRY_MESSAGES.NOT_FOUND)
        : { type: "" },
    (response) => getMonitoringQueueEntriesCountFulfilled(response),
  ],
  onError: [
    getMonitoringQueueEntriesCountRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getMonitoringQueueEntriesCountEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_MONITORING_QUEUE_ENTRIES_COUNT.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(getMonitoringQueueEntriesCountPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default getMonitoringQueueEntriesCountEpic$;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/epics/getMonitoringQueueEntriesCountEpic.js